import { render } from "./achievementsHeader.vue?vue&type=template&id=8dd8cec4&scoped=true"
import script from "./achievementsHeader.vue?vue&type=script&lang=js"
export * from "./achievementsHeader.vue?vue&type=script&lang=js"

import "./achievementsHeader.vue?vue&type=style&index=0&id=8dd8cec4&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dd8cec4"]])

export default __exports__